import { render, staticRenderFns } from "./BaseService.vue?vue&type=template&id=032b5b7d&scoped=true"
import script from "./BaseService.vue?vue&type=script&lang=js"
export * from "./BaseService.vue?vue&type=script&lang=js"
import style0 from "./BaseService.vue?vue&type=style&index=0&id=032b5b7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032b5b7d",
  null
  
)

export default component.exports